import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingDairyPrimaryDataById } from "services";

import { FOOTPRINTING_DAIRY_PRIMARY_DATA } from "consts";

export const useGetFootprintingDairyPrimaryDataById = (primaryDataId: string) => {
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_DAIRY_PRIMARY_DATA, primaryDataId],
      queryFn: () => getFootprintingDairyPrimaryDataById(primaryDataId),
      enabled: !!primaryDataId,
      gcTime: 60000,
    },
    queryClient
  );
};
